import PropTypes from "prop-types";
import React from "react";

export const ExitRowRight = (props) => {
  const { className, role, size, style } = props;

  return (
    <svg {...getProps()}>
      <path d="M2 30.1816L2 0.181641L-2 0.181641L-2 30.1816H2Z" />
      <path d="M14 23.5152H7.907V19.9872H9.023V22.2462H10.373V20.3022H11.489V22.2462H12.884V19.9872H14V23.5152ZM14 15.58L11.948 16.867C12.047 16.903 12.101 16.939 12.173 16.984L14 18.145V19.612L10.913 17.578L7.907 19.558V18.091L9.914 16.777C9.797 16.732 9.734 16.696 9.662 16.651L7.907 15.571V14.104L10.949 16.093L14 14.113V15.58ZM7.907 13.3111V12.0151H14V13.3111H7.907ZM9.041 6.21124V8.09224H14V9.38824H9.041V11.2782H7.907V6.21124H9.041Z" />
    </svg>
  );

  function getProps() {
    return {
      "aria-label": props["aria-label"],
      className,
      height: size,
      role,
      strokeWidth: "0",
      style,
      viewBox: "0 0 22 31",
    };
  }
};

ExitRowRight.displayName = "ExitRowRightIcon";

ExitRowRight.propTypes = {
  /** aria-label text to provide accessibility description for this SVG element. */
  "aria-label": PropTypes.string,

  /**
   * Additional classes for positioning the component. Given classes may only position this component for layout
   * purposes, and cannot change how the component renders in any way.
   */
  className: PropTypes.string,

  /** Name used for aria role. */
  role: PropTypes.string,

  /** Indicates icon's height. The width will be sized accordion to SVG's aspect ratio. */
  size: PropTypes.string,

  /**
   * CSS object to applied to SVG element. Currently, style is expected to only define stroke and fill color, but
   * there is not such a restriction or requirement at this time.
   */
  style: PropTypes.object,
};

ExitRowRight.defaultProps = {
  role: "img",
};
